import {UnstyledButton} from "@mantine/core";
import {Link} from "react-router-dom";
import IconGripVertical from "../../assets/grip-vertical.svg?react";
import classes from "./NavItem.module.css";

type NavItemPropsBase = {
    children: React.ReactNode;
    active?: boolean;
    draggable?: boolean;
    leftSection?: React.ReactNode;
    rightSection?: React.ReactNode;
};

type NavItemProps = NavItemPropsBase &
    ({to: string; onClick?: never} | {onClick: () => void; to?: never});

export function NavItem({
    to,
    onClick,
    children,
    active,
    draggable,
    leftSection,
    rightSection,
}: NavItemProps) {
    const className = `${classes.root} ${draggable ? classes.draggable : ""}`;
    const content = (
        <>
            {draggable && (
                <span className={classes.dragHandle} aria-hidden>
                    <IconGripVertical width={14} height={14} />
                </span>
            )}
            {leftSection && <span className={classes.icon}>{leftSection}</span>}
            {children}
            {rightSection && <span className={classes.chevron}>{rightSection}</span>}
        </>
    );

    if (to) {
        return (
            <UnstyledButton
                component={Link}
                to={to}
                className={className}
                data-active={active || undefined}
            >
                {content}
            </UnstyledButton>
        );
    }

    return (
        <UnstyledButton
            onClick={onClick}
            className={className}
            data-active={active || undefined}
        >
            {content}
        </UnstyledButton>
    );
}
